export default "__VITE_ASSET__W8H07TQT__";